export default __webpack_public_path__ + "static/media/1068.8692e385.png";